/**
 * Channel kinds, named once. The UI twin of the channel-kind block in
 * `pa/core/database/models/content_study.py`.
 *
 * Code compares a channel's kind to these names, never to a string: a literal
 * written before a kind existed fails silently for every kind added after it
 * (the writing board's chat was broken that way). Enforced by
 * `shared/__tests__/channelKindsAreNamed.test.ts`.
 */
export const CHANNEL_KIND = {
  /** The task board: Study's Kanban. */
  board: 'board',
  /** The writing board. */
  writing: 'writing',
  /** The Idea Factory container. */
  ideas: 'ideas',
  /** The Notes container. */
  notes: 'notes',
} as const;

export type ChannelKind = (typeof CHANNEL_KIND)[keyof typeof CHANNEL_KIND];
